// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 695) return "695.f7af2e37022016f8428b.css";
	if (chunkId === 716) return "canvas.b25101e27325d95dacca.css";
	// return url for filenames based on template
	return undefined;
};